/* eslint-disable */

/* webpack注入的变量 */

// 项目运行环境
export const ENV = NODE_ENV;

// 社区2.0API域名
export const API_URL = apiUrl;

// 社区2.0基础路径
export const LINK_URL = linkUrl;

/* eslint-enable */
// 卫视放映厅评论id
export const COMMENT_APP_ID = '10';

export const Tip = {
    ERROR: 'ERROR',
    NODATA: 'NODATA', // 暂无符合条件的内容
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    NOSEARCHDATA: 'NOSEARCHDATA', // 暂无搜索结果
    NOMORE: 'NOMORE', // 没有更多了
    NOINTERNET: 'NOINTERNET', // 无网络
};
// 搜索页面
// 正则匹配地址栏

export const searchPageUrl =
    // eslint-disable-next-line no-nested-ternary
    ENV === 'development'
        ? 'http://172.30.21.20:3000/mobile/news/loc/tvTheater/search'
        : ENV === 'staging'
            ? 'http://test.phtv.ifeng.com/loc/tvTheater/search'
            : 'https://phtv.ifeng.com/loc/tvTheater/search';

export const detailPageUrl =
    // eslint-disable-next-line no-nested-ternary
    ENV === 'development'
        ? 'http://172.30.21.20:3000/mobile/news/loc/tvTheater/details'
        : ENV === 'staging'
            ? 'http://test.phtv.ifeng.com/loc/tvTheater/details'
            : 'https://phtv.ifeng.com/loc/tvTheater/details';

// eslint-disable-next-line no-undef
export const publicPath = linkUrl;

export const devPath =
    // eslint-disable-next-line no-nested-ternary
    ENV === 'development' ? 'http://172.30.21.20:3000/mobile/phtv/loc/tvTheater' : ENV === 'staging' ? 'http://test.phtv.ifeng.com/loc/tvTheater' : 'https://phtv.ifeng.com/loc/tvTheater';
